import { Injectable, Inject } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Sgkc028aRequest, Sgkc028aResponse, SGKC028AService } from 'sg-api';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

/**
 * スライド調整単価取消API使用サービス
 * @export
 * @class UsedSgkc028aService
 */
@Injectable({
    providedIn: 'root'
})
export class UsedSgkc028aService {
    /**
       * コンストラクタ
       * @param {SGKC028AService} sGKC028AService
       * @param {ApiCommonService} apiCommonService
       * @param {FeaturesLibConfig} featuresLibConfig
       * @memberof UsedSgkc028aService
       */
    constructor(private sGKC028AService: SGKC028AService,
        private apiCommonService: ApiCommonService,
        @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

    /**
     * スライド調整単価取消API呼び出し
     * @param {Sgkc028aRequest} sgkc028aRequest
     * @return {Observable<Sgkc028aResponse>}
     * @memberof UsedSgkc028aService
     */
    deleteSlideTankatable(sgkc028aRequest: Sgkc028aRequest): Observable<Sgkc028aResponse> {

        return this.sGKC028AService.kC10WSGKC028APost(<Sgkc028aRequest>this.apiCommonService.setRequestCommon(sgkc028aRequest), 'response')
            .pipe(
                map(response => {
                    // エラーが設定されていないかチェックする
                    this.apiCommonService.checkError(response);
                    return response.body;
                }),
                timeout(Number(this.featuresLibConfig.httpTimeout)),
                catchError((err) => {
                    this.apiCommonService.dispErrorMessage(err, 'sgkc', 'SGKC028A');
                    return throwError(err.message);
                })
            );
    }

}
